export function getParametros(state) {
  return state.parametros;
}






